























import {Vue, Component} from 'vue-property-decorator'
import sdk from '@/lib/kepler/sdk'
import {State} from 'vuex-class'
import Utils from '@/utils'

interface Activity {
  title: string
  description?: string
  color?: string
  icon?: string
  route: string
}

@Component({
  components: {
    BookingActivities: Utils.loadView('BookingActivities'),
    Container: Utils.loadComponent('proxy/Container'),
    CardButton: Utils.loadComponent('CardButton'),
    Avatar: Utils.loadComponent('proxy/Avatar'),
    Img: Utils.loadComponent('proxy/Image'),
  },
})

export default class Activities extends Vue {
  @State((state) => state.profile.driver.profile_picture) public profilePicture!: boolean
  @State((state) => state.subscriptions.plans) public plans!: any[]

  protected get activitiesList(): Activity[] {
    const logged = [
      {
        title: 'activities.profile.title',
        description: 'activities.profile.description',
        color: 'accent',
        icon: 'mdi-account',
        route: 'profile',
      },
      {
        title: 'activities.history.title',
        description: 'activities.history.description',
        color: 'accent',
        icon: 'mdi-calendar-clock',
        route: 'history',
      },
      {
        title: 'activities.plans.title',
        description: 'activities.plans.description',
        color: 'accent',
        icon: 'mdi-text-box-multiple-outline',
        route: 'plans',
      },
    ]
    const notLogged = [
      {
        title: 'activities.plans_not_logged.title',
        description: 'activities.plans_not_logged.description',
        color: 'accent',
        icon: 'mdi-text-box-multiple-outline',
        route: 'plans',
      },
      {
        title: 'activities.register.title',
        description: 'activities.register.description',
        color: 'accent',
        icon: 'mdi-account-plus',
        route: 'registration',
      },
      {
        title: 'activities.login.title',
        description: 'activities.login.description',
        color: 'primary',
        icon: 'mdi-account',
        route: 'login',
      },
    ]

    return this.isLogged ? logged : notLogged
  }

  protected get isLogged() {
    return sdk.people.isLogged()
  }

  protected get otherActivitiesHeader() {
    const t = this.isLogged ? 'activities.other_activities.title' : 'activities.not_logged.title'
    const d = this.isLogged ? 'activities.other_activities.description' : 'activities.not_logged.description'
    const obj = {
      title: this.$isAvailable(t) || '',
      subtitle: this.$isAvailable(d) || '',
    }
    return obj.title || obj.subtitle ? obj : null
  }
}
